import { toast } from "react-toastify";
import { config } from "../../Config";

const createExtension = async ({
    userId,
    extensionName,
    extensionDescription,
    extensionInstructions,
    iconClass,
    category,
    image,
    tools = [],
    customTools=[],
    collaborators = [],
    selectedModel = [],
}) => {
    const apiEndpoint = config.createExtension;

    try {
        if (!userId) {
            throw new Error("Missing required field: userId");
        }
        // if (!image) {
        //     throw new Error("Missing required field: image");
        // }

        const formData = new FormData();
        formData.append("userId", userId);
        formData.append("extensionName", extensionName);
        formData.append("extensionDescription", extensionDescription);
        formData.append("extensionInstructions", extensionInstructions);
        formData.append("iconClass", iconClass);
        formData.append("category", category);
        formData.append("image", image);
        formData.append("customTools", JSON.stringify(customTools));
        console.log(customTools);
        
        tools.forEach((tool, idx) => {
            formData.append(`tools[${idx}]`, tool);
        });
        collaborators.forEach((col, idx) => {
            const collabStr = typeof col === "string" ? col : JSON.stringify(col);
            formData.append(`collaborators[${idx}]`, collabStr);
        });
        selectedModel.forEach((model, idx) => {
            formData.append(`models[${idx}]`, model);
        });

        
        const response = await fetch(apiEndpoint, {
            method: "POST",
            body: formData
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`API error: ${errorText}`);
        }

        const result = await response.json();
        toast.success("Extension created successfully!");
        return result;
    } catch (error) {
        // console.error("Error creating extension:", error.message);
        toast.error(`Failed to create extension: ${error.message}`);
        throw error;
    }
};

export default createExtension;
